import React from 'react';

const Footer = () => {
    return (
        <footer className='footer'>
            <div className="container">
                <p>My first full stack app © 30.01.2022 Rufat</p>
                <h4>Made By Rufat ;)</h4>
            </div>
        </footer>
    );
}

export default Footer;
